import api from "@/lib/api";

/**
 * Start a PayFast checkout — POSTs the returned fields to PayFast so the
 * user is redirected inside the browser (their auth session on our site
 * stays intact via cookies for the ITN + return-url callbacks).
 */
export async function startPayFastCheckout({ package_id, listing_slug, voucher_code }) {
  const { data } = await api.post("/payfast/create", {
    package_id,
    listing_slug: listing_slug || null,
    voucher_code: voucher_code || null,
    origin_url: window.location.origin,
  });

  const form = document.createElement("form");
  form.method = "POST";
  form.action = data.post_url;
  form.style.display = "none";
  Object.entries(data.fields).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = k;
    input.value = String(v);
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
